export function xpNeeded(level = 1) {
  return 100 + (Math.max(1, level) - 1) * 65;
}

export function masteryNeeded(level = 1) {
  return 80 + (Math.max(1, level) - 1) * 55;
}

export function elementMultiplier(attackElement, defenderElement, affinities) {
  if (!attackElement || !defenderElement || attackElement === defenderElement) return 1;
  if (affinities[attackElement]?.strongAgainst === defenderElement) return 1.2;
  if (affinities[defenderElement]?.strongAgainst === attackElement) return .84;
  return 1;
}

export function normalizeRanks(value = {}) {
  return ['attack', 'rasengan', 'clones', 'wind'].reduce((ranks, id) => {
    ranks[id] = Math.min(5, Math.max(1, Number(value[id]) || 1));
    return ranks;
  }, {});
}

export function calculateDamage({ base, level, attackPoints, attackBonus, rank, element = 1, critical = false }) {
  const levelScale = 1 + (Math.max(1, level) - 1) * .075;
  const statsScale = 1 + Math.max(0, attackPoints) * .05;
  const rankScale = 1 + (Math.max(1, rank) - 1) * .025;
  const critScale = critical ? 1.45 : 1;
  return Math.max(1, Math.round(base * levelScale * statsScale * (1 + attackBonus) * rankScale * element * critScale));
}

export function resolveProgress(value, level, needed, pointReward = 1) {
  let nextValue = Math.max(0, value);
  let nextLevel = Math.max(1, level);
  let levelsGained = 0;
  while (nextValue >= needed(nextLevel)) {
    nextValue -= needed(nextLevel);
    nextLevel += 1;
    levelsGained += 1;
  }
  return { value: nextValue, level: nextLevel, levelsGained, points: levelsGained * pointReward };
}

